import { store } from '@/store'
import * as mutations from '@/store/MutationTypes'
// import VueMouseflow from 'vue-mouseflow'

export default (to, from) => {
  store.commit(mutations.LOADING_COMPLETE, to.name)
  // VueMouseflow.logRouteChange(to, { includeRouteParams: true })
}
